/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Pagination } from "~/components";
import { useQueryState } from "~/tools";

type PaginationData = {
  count: number;
  small?: boolean;
};

export function QueryPagination({ count, small }: PaginationData) {
  const [state, , updateQueryState] = useQueryState();
  const { page = 0, limit = 20 } = state;

  return (
    <Pagination
      count={count}
      small={small}
      page={page}
      limit={limit}
      setPageAndLimit={(p, l) =>
        updateQueryState({ page: p.toString(), limit: l.toString() })
      }
    />
  );
}
